import R from 'ramda';
const initialState = {
  contractPeriod: {},
  searchCompanyName: '',
  searchDomain: '',
  open: false,
  dataLoaded: false,
  loadingData: false,
  requests: [],
  selectedIds: [],
  apiCallStatus: '', // processing, success, error
};


export default function requestsWithSameNameOrDomainDialog(state = initialState, { payload, type }) {
  switch (type) {
    case 'OPEN_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME':
      return {
        ...state,
        open: true,
        contractPeriod: payload.contractPeriod,
        searchCompanyName: payload.searchCompanyName,
        searchDomain: payload.searchDomain,
        contractIdToExclude: payload.contractIdToExclude,
      };
    case 'GET_CONTRACT_REQUESTS_BY_COMPANY_STARTED':
      return R.assoc('loadingData', true, state);
    case 'GET_CONTRACT_REQUESTS_BY_COMPANY_SUCCESS':
      return {
        ...state,
        loadingData: false,
        dataLoaded: true,
        requests: payload.list.filter(contract => contract._id !== state.contractIdToExclude),
        selectedIds: payload.list.filter(contract => contract._id !== state.contractIdToExclude).map(R.prop('_id')),
      };
    case 'ON_CHECK_IN_REQUESTS_WITH_SAME_NAME_DIALOG':
      if (payload.checked) {
        return {
          ...state,
          selectedIds: R.append(payload.id, state.selectedIds),
        };
      }
      return {
        ...state,
        selectedIds: state.selectedIds.filter(id => id !== payload.id),
      };
    case 'GET_CONTRACT_REQUESTS_BY_COMPANY_ERROR':
      return R.assoc('loadingData', false, state);
    case 'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG_STARTED':
      return {
        ...state,
        apiCallStatus: 'processing',
      };
    case 'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG_SUCCESS':
      return {
        ...state,
        apiCallStatus: 'success',
      };
    case 'DISCARD_SELECTED_IN_REQUESTS_WITH_SAME_NAME_DIALOG_ERROR':
      return {
        ...state,
        apiCallStatus: 'error',
      };
    case 'ON_SELECT_ALL_IN_REQUESTS_WITH_SAME_NAME_DIALOG':
      return {
        ...state,
        selectedIds: payload.checked ? state.requests.map(R.prop('_id')) : [],
      };
    case 'CLOSE_DIALOG_SHOW_REQUESTS_WITH_SAME_NAME':
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-reducers/requests-with-same-name-or-domain-reducer.js